import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=7e6f04c0&scoped=true"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=7e6f04c0&prod&lang=stylus&scoped=true"
import style1 from "./copy.vue?vue&type=style&index=1&id=7e6f04c0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f04c0",
  null
  
)

export default component.exports